import { render, staticRenderFns } from "./ItemsKitRentList.vue?vue&type=template&id=18320ee2&"
import script from "./ItemsKitRentList.vue?vue&type=script&lang=js&"
export * from "./ItemsKitRentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports